import { useCallback } from 'react';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import { PlanSwitcherGate } from 'components/plan-switcher-gate/plan-switcher-gate.component';

// First-login onboarding step (GEIS-498). Hosts the shared PlanSwitcherGate and
// intercepts its "/member/home" completion deeplink to advance onboarding to the
// All Set screen instead of routing Home — mirroring iOS
// PlanSwitcherStepCoordinator. The returning-login gate routes Home; this one
// does not, so the post-onboarding gate is skipped for first-login members.
export const PlanSwitcherStepView = () => {
  const { send } = OnboardingMachineContext.useActorRef();

  const handleComplete = useCallback(
    () => send({ type: 'navigateToNextView' }),
    [send],
  );

  return <PlanSwitcherGate onComplete={handleComplete} />;
};
